module.exports = __webpack_public_path__ + "57fc6fa5c5bb8a09365fffc79823d20b.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_xlarge_x1/public/news/temp.jpg
// module id = 346
// module chunks = 0